// src/restart/components/ProUpdatesSection.js

import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "./ProUpdatesSection.css"

const ProUpdatesSection = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState({ loading: false, success: "", error: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setStatus({ loading: false, success: "", error: "Email is required." });
      return;
    }

    setStatus({ loading: true, success: "", error: "" });

    try {
      await addDoc(collection(db, "subscriptions"), {
        email,
        createdAt: serverTimestamp(),
        source: "home",
      });

      setStatus({
        loading: false,
        success: "Thank you — we’ll notify you when new modules are available.",
        error: "",
      });

      setEmail("");
    } catch (err) {
      console.error(err);
      setStatus({
        loading: false,
        success: "",
        error: "Could not save. Please try again.",
      });
    }
  };

  return (
    <div style={{ marginBottom: "50px" }}>
      <section id="cta" className="lp-section">
        <div className="pro-updates">
          <h2 className="pro-updates__title" style={{textAlign: "center", marginBottom: "15px"}}>GILDARC</h2>

          <p className="pro-updates__text">
            Additional modules will be made available as time goes on.
          </p>

          <form className="pro-updates__form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Enter your email for updates"
              className="pro-updates__input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <button
              className="pro-updates__button"
              type="submit"
              disabled={status.loading}
            >
              {status.loading ? "Please wait..." : "Notify Me"}
            </button>
          </form>

          {status.success && (
            <p style={{ marginTop: "8px", fontSize: "0.85rem", color: "#16a34a" }}>
              {status.success}
            </p>
          )}

          {status.error && (
            <p style={{ marginTop: "8px", fontSize: "0.85rem", color: "#dc2626" }}>
              {status.error}
            </p>
          )}
        </div>
      </section>
    </div>
  );
};

export default ProUpdatesSection;
